export default "__VITE_ASSET__FZCY06Dw__"